/**
 * Identity format validation - matches backend IdentityFormat.
 * Used for username (email) validation across login, registration, password reset.
 *
 * @see b7-app-main IdentityFormat
 */
// Matches backend IdentityFormat - \u2019 is Unicode right single quotation mark
const IDENTITY_REGEX = /^[a-zA-Z0-9.!#$%&\u2019*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

/**
 * Removes all whitespace from a string.
 *
 * @param {*} value - Value to process.
 * @returns {string} String with all whitespace removed.
 */
export function stripWhitespace(value) {
  return typeof value === "string" ? value.replace(/\s/g, "") : "";
}

/**
 * Validates that a value matches the identity (email) format expected by the backend.
 *
 * @param {*} value - Value to validate (typically string).
 * @returns {boolean} True if valid.
 */
export function validateIdentity(value) {
  if (typeof value !== "string") return false;
  return IDENTITY_REGEX.test(value);
}

export default { validateIdentity, stripWhitespace };
